module.exports = __webpack_public_path__ + "img/erh-3-black.685b38ae.jpg";